import { PostOrPage } from "@tryghost/content-api";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/common/FrontendNav";
import getPage from "../../news/getPage";
import Link from "next/link";
import { getSidebar } from "@/data/news";

export async function getServerSideProps(context: any) {
  const { res } = context;
  res.setHeader(
    "Cache-Control",
    "public, max-age=3600, stale-while-revalidate=4000"
  );
  const page = await getPage("6670344321b45100012f70f8");
  const sidebar = await getSidebar(context.locale);
  return {
    props: {
      page,
      sidebar,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface NewsPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
}
export default function NewsPage({ sidebar }: NewsPageProps) {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{`${t("Table_Tennis")} Bundesliga - TTBL - ${t("Quiz")}`}</title>
        <style>
          {`iframe {
            height: 1000px;
            width: 100%;
          }
          `}
        </style>
      </Head>
      <div>
        <Nav />
        <div className="container container_content container-padding-responsive flex gap-4">
          <div className="bg-white lg:bg-bg-gray p-4 lg:rounded-lg small-text lg:ml-0 w-full">
            <div>
              <div
                className="riddle2-wrapper"
                data-rid-id="MCSJPPKt"
                data-auto-scroll="true"
                data-is-fixed-height-enabled="false"
                data-bg="#fff"
                data-fg="#00205b"
                style={{ margin: "0 auto", maxWidth: "100%", width: "640px" }}
              >
                {/* eslint-disable-next-line @next/next/no-sync-scripts */}
                <script src="https://www.riddle.com/embed/build-embedjs/embedV2.js"></script>
                <iframe
                  src="https://www.riddle.com/embed/a/MCSJPPKt?lazyImages=true&staticHeight=false"
                  allow="autoplay"
                  referrerPolicy="strict-origin"
                  title="Quiz 1"
                ></iframe>
              </div>

              <div
                className="riddle2-wrapper"
                data-rid-id="nuAfmrdg"
                data-auto-scroll="true"
                data-is-fixed-height-enabled="false"
                data-bg="#fff"
                data-fg="#00205b"
                style={{ margin: "0 auto", maxWidth: "100%", width: "640px" }}
              >
                {/* eslint-disable-next-line @next/next/no-sync-scripts */}
                <script src="https://www.riddle.com/embed/build-embedjs/embedV2.js"></script>
                <iframe
                  src="https://www.riddle.com/embed/a/nuAfmrdg?lazyImages=true&staticHeight=false"
                  allow="autoplay"
                  referrerPolicy="strict-origin"
                  title="Quiz 2"
                ></iframe>
              </div>
              <div className="mt-4">
                <Link href="/news/post/66507fa6f0e05200018a75e4">
                  Teilnahmebedingungen
                </Link>
              </div>
            </div>
          </div>
          <div className="max-lg:hidden lg:bg-bg-gray lg:p-4 lg:rounded-lg min-w-[350px]">
            {typeof sidebar.html === "string" && (
              <div dangerouslySetInnerHTML={{ __html: sidebar.html }} />
            )}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
